module.exports = __webpack_public_path__ + "img/home-select.219291db.png";